export default {"src":"/_next/static/media/share_white.a03924bb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};